import { render, staticRenderFns } from "./InputPesquisa.vue?vue&type=template&id=456f6386&scoped=true"
import script from "./InputPesquisa.vue?vue&type=script&lang=js"
export * from "./InputPesquisa.vue?vue&type=script&lang=js"
import style0 from "./InputPesquisa.vue?vue&type=style&index=0&id=456f6386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456f6386",
  null
  
)

export default component.exports